import { useMemo } from 'react';
import { IModalProps, style } from './DeleteModal.config';
import { Box, Button, Modal, Typography, styled } from '@mui/material';
import { useIntl } from 'react-intl';


/**
 * Component to render modal to remove elements
 * @param { boolean } open - Flag to know if modal is oppened or not
 * @param { string } title - Modal header to show principal information
 * @param { string | undefined} warningText - Paragraph explanation optional
 * @param { boolean } hideAcceptButton - Flag to hide or not accept button
 * @param { () => void | undefined} onAcceptHandler - Function to execute when user pushes accept button
 * @param { () => void } onCancelHandler - Function to execute when user pushes cancel button
 */

export const DeleteModal = ({ open, title, warningText, hideAcceptButton, onAcceptHandler, onCancelHandler }: IModalProps) => {
  const { formatMessage } = useIntl();
  const boxJustifyContent = useMemo(() => hideAcceptButton ? "center" : 'space-around', [hideAcceptButton]);
  const boxPaddingInline = useMemo(() => hideAcceptButton ? 0 : 1.5, [hideAcceptButton]);

  return (
    <Modal
      open={open}
      onClose={onCancelHandler}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography align='center' id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        {warningText && <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: "center" }}>
          {warningText}
        </Typography>}
        <Box display='flex' justifyContent={boxJustifyContent} sx={{ mt: 3, paddingInline: boxPaddingInline }}>
          <CancelButton onClick={onCancelHandler}>
            {formatMessage({ id: "button.cancel" })}
          </CancelButton>
          {!hideAcceptButton &&
            <Button
              variant='contained'
              color='primary'
              onClick={onAcceptHandler}
            >
              {formatMessage({ id: "button.accept" })}
            </Button>
          }
        </Box>
      </Box>
    </Modal>
  );
};

//  Styles modification on cancel button

const CancelButton = styled(Button)(({ theme }) => {

  const secondaryColor = theme.palette.secondary.main;
  const whiteColor = '#ffffff';

  return ({
    backgroundColor: whiteColor,
    color: secondaryColor,
    border: `1px solid ${secondaryColor}`,
    '&:hover': {
      backgroundColor: `${secondaryColor}`,
      color: whiteColor,
    },
  })
});